// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.sprite-selector_sprite-selector_q3tBl {
    flex-grow: 1;
    position: relative;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin-right: calc(0.5rem / 2);
    background-color: var(--ui-secondary);
    border-top-right-radius: 0.5rem;
    border-top-left-radius: 0.5rem;
    border-color: var(--ui-black-transparent);
    border-width: 1px;
    border-style: solid;
    border-bottom: 0;
}

.sprite-selector_sprite-wrapper_CXnY0 {
    /*
        Our goal is to fit sprites evenly in a row without leftover space.
        Flexbox's \`space between\` property gets us close, but doesn't flow
        well when the # of items per row > 1 and less than the max per row.

        Solving by explicitly calc'ing the width of each sprite. Setting
        \`border-box\` simplifies things, because content, padding and
        border-width all are included in the width, leaving us only to subtract
        the left + right margins.

        @todo: make room for the scrollbar
    */
    box-sizing: border-box;
    width: calc((100% / 5 ) - 0.5rem);
    max-width: 6rem;
    min-width: 4rem;
    min-height: 4rem; /* @todo: calc height same as width */
    margin: calc(0.5rem / 2);
}

.sprite-selector_sprite_k7gHH {
    height: 100%;
}

.sprite-selector_scroll-wrapper_x59fk {
    /*
       Sets the sprite-selector items as a scrollable pane

        @todo: Safari: pane doesn't stretch to fill height;
        @todo: Adding \`position: relative\` still doesn't fix Safari scrolling pane, and
              also introduces a new bug in Chrome when vertically resizing window down,
              then back up, introduces white space in the outside the page container.
    */
    height: calc(100% - 6rem);
    overflow-y: auto;
}

.sprite-selector_scroll-wrapper-dragging__B3QF {
    background-color: var(--drop-highlight);
}

.sprite-selector_items-wrapper_tzOA7 {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    padding-top: calc(0.5rem / 2);
    padding-left: calc(0.5rem / 2);
    padding-right: calc(0.5rem / 2);
    padding-bottom: 0.5rem;

    overflow: hidden;
}

.sprite-selector_add-button_y8tqB {
    position: absolute;
    bottom: 0.75rem;
}

[dir="ltr"] .sprite-selector_add-button_y8tqB {
    right: 1rem;
}

[dir="rtl"] .sprite-selector_add-button_y8tqB {
    left: 1rem;
}

.sprite-selector_raised_FtaYY {
    background-color: var(--drop-highlight);
    transition: all 0.25s ease;
}

.sprite-selector_raised_FtaYY:hover {
    background-color: var(--drop-highlight);
    transform: scale(1.05);
}

.sprite-selector_raised_FtaYY:hover {
    animation-name: sprite-selector_wiggle_QFBPN;
    animation-duration: 500ms;
    animation-iteration-count: 1;
    animation-timing-function: ease-in-out;
    background-color: var(--drop-highlight);
}

@keyframes sprite-selector_wiggle_QFBPN {
    0% {transform: rotate(3deg) scale(1.05);}
    25% {transform: rotate(-3deg) scale(1.05);}
    50% {transform: rotate(5deg) scale(1.05);}
    75% {transform: rotate(-2deg) scale(1.05);}
    100% {transform: rotate(0deg) scale(1.05);}
}

.sprite-selector_receivedBlocks_NzL49 {
    animation: sprite-selector_glowing_C6qw7 250ms;
}

@keyframes sprite-selector_glowing_C6qw7 {
    10% { box-shadow: 0 0 10px #7fff1e; }
    90% { box-shadow: 0 0 10px #7fff1e; }
    100% { box-shadow: none; }
}

.sprite-selector_placeholder_T4ZDL > .sprite-selector_sprite_k7gHH {
    background: black;
    filter: opacity(15%) brightness(0%);
}
`, "",{"version":3,"sources":["webpack://./src/components/sprite-selector/sprite-selector.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,YAAY;IACZ,kBAAkB;IAClB,2DAA2D;IAC3D,8BAA8B;IAC9B,qCAAqC;IACrC,+BAA+B;IAC/B,8BAA8B;IAC9B,yCAAyC;IACzC,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI;;;;;;;;;;;KAWC;IACD,sBAAsB;IACtB,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,gBAAgB,EAAE,qCAAqC;IACvD,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;;;;;;;KAOC;IACD,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;;IAEnB,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;;IAEtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;AAC1B;;AAEA;IACI,4CAAsB;IACtB,yBAAyB;IACzB,4BAA4B;IAC5B,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,IAAI,mCAAmC,CAAC;IACxC,KAAK,oCAAoC,CAAC;IAC1C,KAAK,mCAAmC,CAAC;IACzC,KAAK,oCAAoC,CAAC;IAC1C,MAAM,mCAAmC,CAAC;AAC9C;;AAEA;IACI,8CAAwB;AAC5B;;AAEA;IACI,MAAM,4BAA4B,EAAE;IACpC,MAAM,4BAA4B,EAAE;IACpC,OAAO,gBAAgB,EAAE;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mCAAmC;AACvC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.sprite-selector {\n    flex-grow: 1;\n    position: relative;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    margin-right: calc(0.5rem / 2);\n    background-color: var(--ui-secondary);\n    border-top-right-radius: 0.5rem;\n    border-top-left-radius: 0.5rem;\n    border-color: var(--ui-black-transparent);\n    border-width: 1px;\n    border-style: solid;\n    border-bottom: 0;\n}\n\n.sprite-wrapper {\n    /*\n        Our goal is to fit sprites evenly in a row without leftover space.\n        Flexbox's `space between` property gets us close, but doesn't flow\n        well when the # of items per row > 1 and less than the max per row.\n\n        Solving by explicitly calc'ing the width of each sprite. Setting\n        `border-box` simplifies things, because content, padding and\n        border-width all are included in the width, leaving us only to subtract\n        the left + right margins.\n\n        @todo: make room for the scrollbar\n    */\n    box-sizing: border-box;\n    width: calc((100% / 5 ) - 0.5rem);\n    max-width: 6rem;\n    min-width: 4rem;\n    min-height: 4rem; /* @todo: calc height same as width */\n    margin: calc(0.5rem / 2);\n}\n\n.sprite {\n    height: 100%;\n}\n\n.scroll-wrapper {\n    /*\n       Sets the sprite-selector items as a scrollable pane\n\n        @todo: Safari: pane doesn't stretch to fill height;\n        @todo: Adding `position: relative` still doesn't fix Safari scrolling pane, and\n              also introduces a new bug in Chrome when vertically resizing window down,\n              then back up, introduces white space in the outside the page container.\n    */\n    height: calc(100% - 6rem);\n    overflow-y: auto;\n}\n\n.scroll-wrapper-dragging {\n    background-color: var(--drop-highlight);\n}\n\n.items-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n\n    padding-top: calc(0.5rem / 2);\n    padding-left: calc(0.5rem / 2);\n    padding-right: calc(0.5rem / 2);\n    padding-bottom: 0.5rem;\n\n    overflow: hidden;\n}\n\n.add-button {\n    position: absolute;\n    bottom: 0.75rem;\n}\n\n[dir=\"ltr\"] .add-button {\n    right: 1rem;\n}\n\n[dir=\"rtl\"] .add-button {\n    left: 1rem;\n}\n\n.raised {\n    background-color: var(--drop-highlight);\n    transition: all 0.25s ease;\n}\n\n.raised:hover {\n    background-color: var(--drop-highlight);\n    transform: scale(1.05);\n}\n\n.raised:hover {\n    animation-name: wiggle;\n    animation-duration: 500ms;\n    animation-iteration-count: 1;\n    animation-timing-function: ease-in-out;\n    background-color: var(--drop-highlight);\n}\n\n@keyframes wiggle {\n    0% {transform: rotate(3deg) scale(1.05);}\n    25% {transform: rotate(-3deg) scale(1.05);}\n    50% {transform: rotate(5deg) scale(1.05);}\n    75% {transform: rotate(-2deg) scale(1.05);}\n    100% {transform: rotate(0deg) scale(1.05);}\n}\n\n.receivedBlocks {\n    animation: glowing 250ms;\n}\n\n@keyframes glowing {\n    10% { box-shadow: 0 0 10px #7fff1e; }\n    90% { box-shadow: 0 0 10px #7fff1e; }\n    100% { box-shadow: none; }\n}\n\n.placeholder > .sprite {\n    background: black;\n    filter: opacity(15%) brightness(0%);\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `sprite-selector_sprite-selector_q3tBl`;
export { _1 as "sprite-selector" };
export var spriteSelector = `sprite-selector_sprite-selector_q3tBl`;
var _2 = `sprite-selector_sprite-wrapper_CXnY0`;
export { _2 as "sprite-wrapper" };
export var spriteWrapper = `sprite-selector_sprite-wrapper_CXnY0`;
export var sprite = `sprite-selector_sprite_k7gHH`;
var _3 = `sprite-selector_scroll-wrapper_x59fk`;
export { _3 as "scroll-wrapper" };
export var scrollWrapper = `sprite-selector_scroll-wrapper_x59fk`;
var _4 = `sprite-selector_scroll-wrapper-dragging__B3QF`;
export { _4 as "scroll-wrapper-dragging" };
export var scrollWrapperDragging = `sprite-selector_scroll-wrapper-dragging__B3QF`;
var _5 = `sprite-selector_items-wrapper_tzOA7`;
export { _5 as "items-wrapper" };
export var itemsWrapper = `sprite-selector_items-wrapper_tzOA7`;
var _6 = `sprite-selector_add-button_y8tqB`;
export { _6 as "add-button" };
export var addButton = `sprite-selector_add-button_y8tqB`;
export var raised = `sprite-selector_raised_FtaYY`;
export var wiggle = `sprite-selector_wiggle_QFBPN`;
export var receivedBlocks = `sprite-selector_receivedBlocks_NzL49`;
export var glowing = `sprite-selector_glowing_C6qw7`;
export var placeholder = `sprite-selector_placeholder_T4ZDL`;
export default ___CSS_LOADER_EXPORT___;
